/**
 * Column in site map with links of months that clicks out
 * to page with articles for that year & month.
 * This is used for both articles & advice site map as well as buying guides.
 */

import React from 'react'
import { object } from 'prop-types'

import { SiteMapMonthListing } from './SiteMapMonthListing'

export const SiteMapYearListing = ({ data }) => {
	const years = Object.keys(data)
	return (
		<>
			{years.map((year) => (
				<SiteMapMonthListing year={year} months={data[year]} key={year} />
			))}
		</>
	)
}

SiteMapYearListing.propTypes = {
	data: object,
}
